import { moduleProviderFactory } from "core/providers";
import { NikoFacilityOrderInsuranceReviewPreview } from "application/niko-facility-order-insurance-review/pages";

(function () {
    moduleProviderFactory.application.register({
        routes: [
            {
                name: "master.app.main.niko-facility-order",
                pattern: "/niko-facility-orders",
                children: [
                    {
                        name: "master.app.main.niko-facility-order.insurance-review-preview",
                        pattern: "/:id/insurance-review",
                        authorization: "administrationSection.read",
                        component: NikoFacilityOrderInsuranceReviewPreview,
                        data: {
                            //title: "",
                            crumbs: [
                                {
                                    title: "NIKO_FACILITY_ORDER.CRUMB.INSURANCE_REVIEW",
                                    route: 'master.app.main.niko-facility-order.insurance-review-preview'
                                }
                            ],
                            back: "master.app.main.niko-facility-order.list",
                        }
                    }
                ]
            }
        ],
        menu: [
            {
                title: "MENU.FACILITY_ORDERS",
                icon: "package",
                authorization: "administrationSection.read",
                order: 5,
                subMenu: [
                    {
                        title: "MENU.NIKO_FACILITY_ORDERS",
                        authorization: "administrationSection.read",
                        route: "master.app.main.niko-facility-order.list",
                        order: 3,
                    }
                ]
            },
        ]
    });
})();